import AccessTimeIcon from '@mui/icons-material/AccessTime';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useController } from 'react-hook-form';

import { AVAILABILITIES_INPUT_SX } from 'reservations/availabilities/constants';
import { useAvailabilitiesContext } from 'reservations/availabilities/providers/AvailabilitiesProvider';

type TimePickerSlot = {
  time?: string;
  index: number;
};

const TimePicker = () => {
  const { timePickerSlots } = useAvailabilitiesContext();
  const {
    field: { onChange, name, value, ref, onBlur }
  } = useController({
    name: 'time'
  });

  return (
    <FormControl fullWidth sx={AVAILABILITIES_INPUT_SX}>
      <InputLabel id="reservations-time">Time</InputLabel>
      <Select
        data-testid="time-picker"
        disabled={timePickerSlots.length <= 1}
        labelId="reservations-time"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        inputRef={ref}
        label="Time"
        IconComponent={KeyboardArrowDownIcon}
        startAdornment={
          <InputAdornment position="start">
            <AccessTimeIcon />
          </InputAdornment>
        }
      >
        {timePickerSlots.map((option: TimePickerSlot) => {
          // NOTE: this is the case where the value we choose for time is Anytime
          // we want to make sure that the value is outside of the range of the array
          // of TimePickerSlots
          return (
            <MenuItem value={option.index} key={option.time}>
              {option.time}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default TimePicker;
